import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

// prettier-ignore
const PessoaListar = React.lazy(() => import('../pages/pessoa-listar'))
const PessoaCriar = React.lazy(() => import('../pages/pessoa-criar'))
const PessoaEditar = React.lazy(() => import('../pages/pessoa-editar'))
const PessoaPainel = React.lazy(() => import('../pages/pessoa-painel'))
const PessoaEnderecoCriar = React.lazy(
  () => import('../features/pessoa-endereco/pages/criar'),
)
const PessoaEnderecoEditar = React.lazy(
  () => import('../features/pessoa-endereco/pages/editar'),
)
const PessoaContatoCriar = React.lazy(
  () => import('../features/pessoa-contato/pages/criar'),
)
const PessoaContatoEditar = React.lazy(
  () => import('../features/pessoa-contato/pages/editar'),
)

export default function Component() {
  return (
    <Routes>
      <Route index element={<PessoaListar />} />
      <Route path="novo" element={<PessoaCriar />} />
      <Route path=":person_id" element={<Outlet />}>
        <Route index element={<PessoaPainel />} />
        <Route path="editar" element={<PessoaEditar />} />
        <Route path="enderecos/novo" element={<PessoaEnderecoCriar />} />
        <Route
          path="enderecos/:address_id"
          element={<PessoaEnderecoEditar />}
        />
        <Route path="contatos/novo" element={<PessoaContatoCriar />} />
        <Route path="contatos/:contact_id" element={<PessoaContatoEditar />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
